import { render, staticRenderFns } from "./recruitmentData.vue?vue&type=template&id=9dcc723e&scoped=true"
import script from "./recruitmentData.vue?vue&type=script&lang=js"
export * from "./recruitmentData.vue?vue&type=script&lang=js"
import style0 from "./recruitmentData.vue?vue&type=style&index=0&id=9dcc723e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc723e",
  null
  
)

export default component.exports